import poster from '@/static/assets/reviews/AlexFaust_Pet/video.jpg';
import subs from '@/static/assets/reviews/AlexFaust_Pet/subs.vtt';
import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';

export const AlexFaust: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Alex',
  videoUrl: `${ASSETS_URL}/pet/AlexFaust_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
